// menuItems.js
import { isAdminOrManagerRole } from "./utils/userRoles";
import { FEATURES } from "./config/features";

export const getMenuItems = (authenticated, user = null) => {
  if (authenticated) {
    const menuItems = [
      { text: "Home", path: "/" },
      { text: "About Us", path: "/about" },
      { text: "Dashboard", path: "/dashboard" },
      ...(FEATURES.PROJECTS_ENABLED
        ? [{ text: "Projects", path: "/requests" }]
        : []),
      {
        text: "Email Marketing",
        submenu: [
          { text: "Campaigns", path: "/campaign-dashboard" },
          { text: "Create Campaign", path: "/campaigns" },
          { text: "Templates", path: "/templates" },
          { text: "Contact Groups", path: "/contacts" },
          { text: "Subscribe Forms", path: "/subscribe-forms" },
          { text: "Verified Emails", path: "/emails" },
          { text: "Verified Domains", path: "/domains" },
        ],
      },
      // ????? ????? ??? SMS ? ?????????? ??????????
      {
        text: "SMS",
        submenu: [
          { text: "Campaigns", path: "/sms/dashboard" },
          { text: "Create Campaign", path: "/sms/campaign" },
          { text: "Contact Groups", path: "/sms/contacts" },
          { text: "Verified Phones", path: "/sms/phones" },
        ],
      },
    ];

    // Добавляем Parsing и System Monitoring для админов и менеджеров
    if (user && isAdminOrManagerRole(user.role)) {
      menuItems.splice(2, 0, {
        text: "System Monitoring",
        path: "/mobile-monitoring",
      });
      menuItems.splice(2, 0, { text: "Parsing", path: "/parsing" });
    }

    return menuItems;
  } else {
    return [
      { text: "Home", path: "/" },
      { text: "About Us", path: "/about" },
    ];
  }
};
